var angular = require('angular');

require('angular-sanitize');
require('bootstrap');
require('jquery');
require('moment');


require('angular-schema-form/dist/schema-form.min');
require('./resources/bootstrap-decorator.js');

require('angular-bootstrap-datetimepicker');
require('angular-bootstrap-datetimepicker/src/js/datetimepicker.templates.js');
require('angular-bootstrap-datetimepicker/src/css/datetimepicker.css');


require('ui-select');
require('ui-select/dist/select.css');
require('underscore');
require('angular-translate');
require('angular-schema-form-dynamic-select');

require('bootstrap-vertical-tabs/bootstrap.vertical-tabs.css');

require('select2/select2.css');
require('./resources/fix.css');
require('ng-file-upload');

//require('imports-loader?moment=moment!bootstrap-daterangepicker/daterangepicker.js');
require('bootstrap-daterangepicker/daterangepicker.js');
require('bootstrap-daterangepicker/daterangepicker.css');
//require('imports-loader?moment=moment!angular-daterangepicker/js/angular-daterangepicker.js');
require('angular-daterangepicker/js/angular-daterangepicker.js');


var app = angular.module('amt.forms', [
    'schemaForm',
    'ngSanitize',
    'ui.bootstrap.datetimepicker',
    'pascalprecht.translate',
    'ui.select',
    'daterangepicker',
    'ngFileUpload'
]);
require('./resources/api_service').default(app);
require('./resources/modal').default(app);
require('./resources/inline').default(app);

var modal_tpl = require('./resources/modal.html');

app.run(['$templateCache', function ($templateCache) {
    $templateCache.put('amt.forms/modal.html', modal_tpl);
}]);

export default app.name;
